var initializeCacListBlock = function(block){
	
	var userZip = localStorage.getItem("user-zip") ? localStorage.getItem("user-zip") : 0;
	var container = block.find(".cac-list-container");
	var style = container.data('style');
	var excludeId = container.data('exclude-id') || 0;
	
	jQuery.ajax({
		url:"/wp-admin/admin-ajax.php",
		type:'POST',
		data: {
			action: 'get_user_cacs',
			'user-zip': userZip,
			style: style,
			'exclude_id': excludeId // Match the exact data attribute name
		},
		success:function(results){
			jQuery(".cac-list-container", block).html(results);
		}
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	// Initialize blocks
	jQuery('.wp-block-cac-list').each(function(){
		initializeCacListBlock(jQuery(this));
	});

	// Initialize standalone containers (e.g. on single-cac.php)
	if (!jQuery('.wp-block-cac-list').length) {
		jQuery('.cac-list-container').each(function(){
			initializeCacListBlock(jQuery(this).parent());
		});
	}
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=cac-list', initializeCacListBlock);
